import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

const WizardNavigation = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  onPublish,
  loading,
  canProceed
}) => {
  const intl = useIntl();
  const isFirstStep = currentStep === 1;
  const isFinalStep = currentStep === totalSteps;

  return (
    <div className="flex items-center justify-between">
      {/* Left side - Previous button */}
      <div className="flex-1">
        {!isFirstStep && (
          <button
            type="button"
            onClick={onPrevious}
            disabled={loading}
            className="inline-flex items-center px-6 py-3 border border-succession-border shadow-sm text-sm font-semibold rounded-lg text-succession-text-secondary bg-succession-bg-primary hover:bg-succession-hover-bg hover:border-succession-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-succession-primary disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105"
          >
            <svg className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <FormattedMessage id="succession_deals.wizard.navigation.previous" />
          </button>
        )}
      </div>

      {/* Right side - Next/Publish button */}
      <div className="flex-1 flex justify-end">
        {isFinalStep ? (
          <button
            id="deal-wizard-publish-button"
            type="button"
            onClick={onPublish}
            disabled={loading || !canProceed}
            className="inline-flex items-center px-8 py-3 border border-transparent text-sm font-bold rounded-lg shadow-lg text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105 hover:shadow-xl"
          >
            {loading ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <FormattedMessage id="succession_deals.wizard.navigation.publishing" />
              </>
            ) : (
              <>
                <svg className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                </svg>
                <FormattedMessage id="succession_deals.wizard.navigation.publish" />
              </>
            )}
          </button>
        ) : (
          <button
            type="button"
            onClick={onNext}
            disabled={loading || !canProceed}
            className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-semibold rounded-lg shadow-lg text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-succession-primary disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105 hover:shadow-xl"
            style={{ backgroundColor: 'var(--succession-primary)' }}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--succession-primary-hover)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--succession-primary)'}
          >
            <FormattedMessage id="succession_deals.wizard.navigation.next" />
            <svg className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

WizardNavigation.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  canProceed: PropTypes.bool
};

WizardNavigation.defaultProps = {
  loading: false,
  canProceed: true
};

export default WizardNavigation; 